import React, { useState, useEffect, useLayoutEffect } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import _ from "lodash"
import { v4 } from "uuid"
import Swal from 'sweetalert2'
import axios from 'axios'
import { Card, Row, Col, Accordion } from 'react-bootstrap'
import BoxItemDropDown from '../components/BoxItemDropDown'


var checkVRN = false;

const headers = {
    'Content-Type': 'application/json',
    'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
}

function MapButton(props) {
    const BoxName = props.BoxName;
    if (BoxName === 'Mapped') {
        //return <UserGreeting />;
        return (
            <div>
                <button>Tag</button>
            </div>
        )
    }
    return (
        <>
        </>
    )
}


function DNDcomponent(props) {
    const showAccordion = props.showAccordion;
    const count = 0;
    //console.log(props)
    return (

        <Droppable droppableId={props.droppableId}>
            {(provided, snapshot) => {
                return (
                    <Card.Body
                        className="pt-2"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{ height: '300px', overflowY: 'auto', scrollbarColor: 'yellowgreen' }}
                    >
                        {props.vrndata.items.map((el, index) => {
                            //console.log(el)
                            return (
                                <Draggable key={el.id} index={index} draggableId={el.id} origin="test">
                                    {(provided, snapshot) => {
                                        return (
                                            <div>
                                                {showAccordion ? <Accordion>
                                                    <div
                                                        className={`item ${snapshot.isDragging && "dragging"}`}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <div className="box-item btn btn-default w-100">
                                                            <BoxItemDropDown index={index} name={el.caption} accordionSubItems={el.pans} />
                                                            {/* {el.id} */}
                                                        </div>
                                                    </div>
                                                </Accordion>

                                                    :

                                                    <div
                                                        className={`item ${snapshot.isDragging && "dragging"}`}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <div className="box-item btn btn-default w-100 ">
                                                            {/* <small className="pull-left">
                                                                {el.caption.split(" (")[0]}
                                                            </small> */}

                                                            <><small className="pull-left">{el.caption.split(" (")[0]}</small><br /><small class="pull-right">{el.caption.split(" (")[1]}</small></>

                                                            

                                                        </div>
                                                    </div>


                                                }
                                            </div>
                                        )
                                    }}
                                </Draggable>
                                // {props.accordion && </Accordion>}
                            )
                        })}
                        {provided.placeholder}

                    </Card.Body>
                )
            }}
        </Droppable>

    );
}

export default DNDcomponent;